import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { TaxGroupModel }      from './typings/tax-group';
import { TaxGroupsService }   from './tax-groups.service';
import { TaxGroupsComponent } from './tax-groups.component';

export const TaxGroupsStates : Array<NgHybridStateDeclaration> = [
  {
    component: TaxGroupsComponent,
    name     : 'app.tax-groups',
    resolve  : [
      {
        deps     : [ TaxGroupsService ],
        resolveFn: ( taxGroupsService : TaxGroupsService ) : Promise<Array<TaxGroupModel>> => taxGroupsService.get(),
        token    : 'groups'
      }
    ],
    url: '/tax-groups'
  }
];
